import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { CTAContainer } from 'components/CTAContainer'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Background = styled.div`
  background-color: ${style(theme => theme.colors.slate)};
  min-height: 100vh;
  height: 100%;
  background-repeat: no-repeat;
  overflow-y: auto;
`

export const LayoutContents = styled.div`
  padding: 10px 0px 14px 0px;
  position: relative;
  min-height: 100vh;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px 30px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    overflow-y: auto;
    justify-content: flex-start;
  }
`

export const TextContainer = styled.div`
  text-align: center;
  padding-bottom: 40px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 110px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

export const ButtonContainer = styled(CTAContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: transparent;
  }
`

export const Title = styled(Heading2)`
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  color: ${style(theme => theme.colors.white)};
`

export const MessageContainer = styled.div`
  & p:first-child {
    margin-bottom: 26px;
  }
`

export const Message = styled(Body)`
  margin: 0 auto;
  max-width: 315px;
  color: ${style(theme => theme.colors.stoneLight)};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`

export const Footer = styled(Body)`
  font-size: 10px;
  line-height: 16px;
  font-weight: 300;
  margin: 0px auto;
  max-width: 315px;
  color: ${style(theme => theme.colors.stoneLight)};
  text-align: center;
`

export const SuccessIcon = styled.img`
  margin: 50px auto 20px;
  max-width: 550px;
  max-height: 350px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 20px;
  }
`

export const SignatureImage = styled.img`
  max-width: 200px;
  top: 479px;
  display: block;
  margin: 20px auto 0;
`

export const MOCButton = styled(Button)`
  width: 220px;
  background: ${style(theme => theme.colors.green)};
  color: black;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 315px;
    min-width: 90%;
    max-width: 100%;
  }
`
